export function getTabs(tabGroupId) {
    return Array.from(document.querySelectorAll(`[id="${tabGroupId}"] [role="tab"]:not(:disabled)`)).map((tab) => tab.getAttribute('data-tab-id'));
}
